import { type IpFilter, IpFilterType } from "Interfaces";

export const DUMMY_FILTER: IpFilter[] = [
	{
		type: IpFilterType.SINGLE_ADDRESS,
		addresses: [ "192.168.1.1" ]
	},
	{
		type: IpFilterType.ADDRESS_RANGE,
		addresses: [ "192.168.20.5", "192.168.20.254" ]
	},
	{
		type: IpFilterType.SINGLE_ADDRESS,
		addresses: [ "12.45.45.104" ]
	}
];
